<div class="fullscreen-panel collection-select-panel-wrapper">
  <div class="collection-select-panel-content-row" fxLayout="column"   fxLayoutAlign="center center" >
    <span class="select-title">{{title}}</span>
  </div>
  <div class="gallery-thumb-wrapper-composite" fxLayout="row wrap" fxLayoutAlign="space-between start" >
    <app-thumbnail-gallery [sourceCollections]="sourceCollections" (collectionClicked)="onCollectionClicked($event)" [galleryMode]="GALLERY_MODE.SELECTION" class="no-title last-slider"></app-thumbnail-gallery>
  </div>
</div>
<div class="background-overlay dark-background-overscroll"></div>
